import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  style: {
    margin: '30px',
  },
}))

export default useStyles
